export const SUPPORT_EMAIL =
  process.env.REACT_APP_SUPPORT_EMAIL ?? 'support@digestaid.health';
